module.exports = __webpack_public_path__ + "img/10979924_L.df59f562.png";